module.exports = __webpack_public_path__ + "Simple-Line-Icons.78f07e2c2a535c26ef21.woff";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/simple-line-icons/Simple-Line-Icons.woff?v=2.4.0
// module id = ../../../../../src/assets/fonts/simple-line-icons/Simple-Line-Icons.woff?v=2.4.0
// module chunks = 40